import { render, staticRenderFns } from "./CreateMail.vue?vue&type=template&id=12bfcb31&scoped=true"
import script from "./CreateMail.vue?vue&type=script&lang=js"
export * from "./CreateMail.vue?vue&type=script&lang=js"
import style0 from "./CreateMail.vue?vue&type=style&index=0&id=12bfcb31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bfcb31",
  null
  
)

export default component.exports